(function () {
  var videos = document.querySelectorAll('video.js-homepage-defer-video');
  if (!videos.length) return;

  function activate(video) {
    if (video.getAttribute('data-defer-activated') === '1') return;
    video.setAttribute('data-defer-activated', '1');
    var source = video.querySelector('source[data-src]');
    if (!source || source.src) return;
    var url = source.getAttribute('data-src');
    if (!url) return;
    source.src = url;
    video.load();
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {});
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          activate(entry.target);
        });
      },
      { rootMargin: '150px 0px', threshold: 0.01 }
    );
    videos.forEach(function (v) {
      io.observe(v);
    });
  } else {
    videos.forEach(activate);
  }
})();
